/** 바이트를 16진수 글자로 (한 바이트 = 두 글자) */
export function toHex(bytes: Uint8Array): string {
  return [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('')
}

/** 무작위 바이트 (`crypto.getRandomValues`) */
export function randomBytes(n: number): Uint8Array {
  const bytes = new Uint8Array(n)
  crypto.getRandomValues(bytes)
  return bytes
}

/** SHA-256 을 16진수 64글자로. 화면과 서버(`functions`)가 같이 쓴다. */
export async function sha256Hex(text: string): Promise<string> {
  return toHex(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text))))
}
